import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import airportStyle from 'components/bolt/airport/airport.sss';
import Store from 'store/store';

export default class Weather extends Component {
	constructor(props) {
		super(props);
		this.startWeatherAnimSequence = this.startWeatherAnimSequence.bind(this);
		this.state = {
			activeWeatherAnimFrame: 0,
			icon: 'sun'
		};
	}

	componentDidMount() {
		this.startWeatherAnimSequence();
		Store.on('SET_WEATHER_ICON', (icon) => this.state.icon != icon && this.setState({ icon: icon }));
	}

	componentDidUpdate(prevProps) {
		const { motionPaused } = this.props;
		if (prevProps.motionPaused !== motionPaused) {
			if (motionPaused) {
				window.clearTimeout(this.weatherAnimTimer);
				this.$moonVideo?.pause();
			} else {
				this.startWeatherAnimSequence();
				this.$moonVideo?.play();
			}
		}
	}

	componentWillUnmount() {
		window.clearTimeout(this.weatherAnimTimer);
	}

	startWeatherAnimSequence() {
		const { activeWeatherAnimFrame } = this.state;
		if (activeWeatherAnimFrame > 37) {
			this.setState({ activeWeatherAnimFrame: 0 });
			this.weatherAnimTimer = setTimeout(this.startWeatherAnimSequence, 2500);
		} else {
			this.setState({ activeWeatherAnimFrame: activeWeatherAnimFrame + 1 });
			this.weatherAnimTimer = setTimeout(this.startWeatherAnimSequence, 1 / 60 * 1000);
		}
	}

	render({ imageRoot, videoRoot, copy }) {
		const { activeWeatherAnimFrame, icon } = this.state;
		return (
			<div class={airportStyle.weatherContainer}>
				<img class={airportStyle.weatherContainerImage} src={`${imageRoot}/airport/header/wfhll2.webp`} alt={copy.$altWeatherIcon} />
				{icon == 'sun' && (
					<div class={airportStyle.weatherAnim}>
						{new Array(41).fill('x').map((el, i) => (
							<img
								class={joinClasses(airportStyle.weatherAnimFrame, activeWeatherAnimFrame === i && airportStyle.active)}
								src={`${imageRoot}/airport/header/e2kurm/${i}.webp`}
								key={`weather-anim-frame-${i}`}
							/>
						))}
					</div>
				)}
				{icon == 'moon' && (
					<video class={airportStyle.moon} ref={video => this.$moonVideo = video} autoplay loop muted playsinline>
						<source src={`${videoRoot}/airport/header/dh2ode.mov`} type={'video/mp4; codecs="hvc1"'} />
						<source src={`${videoRoot}/airport/header/dh2ode.webm`} type={'video/webm; codecs="vp9"'} />
					</video>
				)}
				<div class={airportStyle.headerLines} />
			</div>
		);
	}
}